import { BasicDetailsSection } from '@xemplo/user-form-sections';

import { AssignRoleSection } from './assign-role-section';
import * as S from './create-company-user-form.styles';

export function CreateCompanyUserForm() {
  return (
    <S.Form>
      <BasicDetailsSection />
      <AssignRoleSection />
    </S.Form>
  );
}
